import React, {Fragment, useState, useContext } from 'react';
import * as XLSX from 'xlsx';

import UserProfileContext from '../context/userprofilecontext.js';

import PageSkeleton from "../components/ui/pageskeleton.js";
import { useGetTransactions } from "../api/transactions.js";
import SnackbarContext from '../context/snackbar-context.js';
import { dateGetter } from '../components/ui/type-utilities';
import { useGetBankAccounts } from '../api/bankaccounts.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

function EmergencyDumpView(props) {
  const [isDownloading, setIsDownloading] = useState(false);

  const snackbarContext = useContext(SnackbarContext);
  const userProfileContext = useContext(UserProfileContext);

  const transactionResult = useGetTransactions();
  const transactionsData = transactionResult.data ;

  const bankAccountsResult = useGetBankAccounts();
  const accountsData = bankAccountsResult.data ;






  const isFetching = transactionResult.isLoading || bankAccountsResult.isLoading;



  const downloadExcel = () => {
    setIsDownloading(true);

    // Process transactionsData
    const processedTransactionsData = transactionsData.map(transaction => ({
      ...transaction,
      // W. Belding commented out next line, not sure why this was here, that field is not in the data
      //'Transaction Update Date': dateGetter(transaction['Transaction Update Date']),
    }));

    const wsTransactions = XLSX.utils.json_to_sheet(processedTransactionsData);
    const wsAccounts = XLSX.utils.json_to_sheet(accountsData);

    // Adjust column widths based on data length
    const adjustColumnWidth = (sheet, data) => {
      if (data.length === 0) return;

      const colWidths = Object.keys(data[0]).map(key => ({
        wch: Math.max(
          ...data.map(row => (row[key] ? row[key].toString().length : 0)),
          key.length
        ),
      }));

      sheet['!cols'] = colWidths;
    };

    // Adjust widths for the Transactions sheet
    adjustColumnWidth(wsTransactions, processedTransactionsData);

    // Adjust widths for the Account Details sheet
    adjustColumnWidth(wsAccounts, accountsData);

    // Create a new workbook and append the worksheets
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsTransactions, 'Transactions');
    XLSX.utils.book_append_sheet(wb, wsAccounts, 'Account Details');

    try {
      const caseName = userProfileContext.userProfile?.currentCase?.caseName || '';
      XLSX.writeFile(wb, `EmergencyCaseDump${caseName}.xlsx`);
    } catch (error) {
      console.error('Error generating Excel file:', error);
      snackbarContext.openSnackbarError(`Error generating Excel file: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };



  const buttonStyle = {
    display: 'block',
    margin: '20px auto',
    padding: '20px 40px',
    fontSize: '24px',
    backgroundColor: isFetching || isDownloading ? 'grey' : 'red',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: isFetching || isDownloading ? 'not-allowed' : 'pointer',
    textAlign: 'center',
  };



  if (!transactionsData || !accountsData) {
    return (
      <Fragment>
        <PageSkeleton />
      </Fragment>
    );
  }


  return (
    <Fragment>
      <button
        style={buttonStyle}
        onClick={downloadExcel}
        disabled={isFetching || isDownloading}
      >
        {isFetching
          ? 'Loading Data...'
          : isDownloading
          ? 'Downloading...'
          : 'Emergency Download'}
      </button>
      </Fragment>
  );
}

  export default function EmergencyDump(props) {
  return (
      <CaseDatabaseCheck>
    <CurrentCaseRequired>
      <EmergencyDumpView />
    </CurrentCaseRequired>
  </CaseDatabaseCheck>
  );

  }
